import browserCheck from '@ta-interaktiv/browsercheck';

var _NATIVE_APP_SHARE_URLS = {
    facebook: 'app://share_facebook',
    twitter: 'app://share_twitter',
    whatsapp: 'app://share_whatsapp',
    share: 'app://share_email'
};
var _NATIVE_SHARE_URL_CONDITION = browserCheck.isNativeApp;
function twitterShareUrl(parameters) {
    if (_NATIVE_SHARE_URL_CONDITION) {
        return _NATIVE_APP_SHARE_URLS['twitter'];
    }
    var title = parameters.title, url = parameters.url, via = parameters.via, hashtags = parameters.hashtags;
    if (url === undefined) {
        throw new TypeError('[Share URL Factory] URL not defined');
    }
    var shareUrl = 'https://twitter.com/intent/tweet';
    shareUrl += "?url=" + encodeURIComponent(url);
    if (title) {
        shareUrl += "&text=" + encodeURIComponent(title);
    }
    if (via) {
        shareUrl += "&via=" + encodeURIComponent(via);
    }
    if (hashtags) {
        shareUrl += "&hashtags=" + encodeURIComponent(hashtags.join(','));
    }
    return shareUrl;
}
function facebookShareUrl(parameters) {
    if (_NATIVE_SHARE_URL_CONDITION) {
        return _NATIVE_APP_SHARE_URLS['facebook'];
    }
    var url = parameters.url, hashtags = parameters.hashtags, facebook_id = parameters.facebook_id;
    if (url === undefined) {
        throw new TypeError('[Share URL Factory] URL not defined');
    }
    if (facebook_id === undefined) {
        throw new TypeError('[Share URL Factory] Facebook ID not defined.');
    }
    var shareUrl = 'https://www.facebook.com/dialog/share';
    shareUrl += '?display=popup';
    shareUrl += "&app_id=" + facebook_id;
    shareUrl += "&href=" + encodeURIComponent(url);
    shareUrl += "&redirect_uri=" + encodeURIComponent(url);
    if (hashtags) {
        shareUrl += "&hashtag=" + encodeURIComponent("#" + hashtags[0]);
    }
    return shareUrl;
}
function whatsappShareUrl(parameters) {
    if (_NATIVE_SHARE_URL_CONDITION) {
        return _NATIVE_APP_SHARE_URLS['whatsapp'];
    }
    var title = parameters.title, url = parameters.url;
    if (url === undefined) {
        throw new TypeError('[Share URL Factory] URL not defined');
    }
    var shareUrl = 'whatsapp://send';
    shareUrl += "?text=" + encodeURIComponent(url);
    if (title) {
        shareUrl += "" + encodeURIComponent(' ') + encodeURIComponent(title);
    }
    return shareUrl;
}
function shareShareUrl(parameters) {
    if (_NATIVE_SHARE_URL_CONDITION) {
        return _NATIVE_APP_SHARE_URLS['share'];
    }
    var url = parameters.url;
    if (url === undefined) {
        throw new TypeError('[Share URL Factory] Share URL not defined');
    }
    return encodeURI(url);
}
var shareURLFactory = {
    twitter: twitterShareUrl,
    facebook: facebookShareUrl,
    whatsapp: whatsappShareUrl,
    share: shareShareUrl
};

export default shareURLFactory;
export { shareURLFactory };
//# sourceMappingURL=index.js.map
